import { Controller } from "@hotwired/stimulus"
import { clearPendingInvitationContinuation } from "./support/auth_continuation"

export default class extends Controller {
    connect() {
        clearPendingInvitationContinuation()
    }
}
